import React from 'react';
import logo from './images/logo-correios-menu.png';
import './style/App.css';
import './style/normalize.css';
import Numero from './Components/numero'; 

function App() {
  return (
    <div className="content">
      <div className="content-left">
          <div className="content-left--main">
              <div className="content-left--main-img">
                  <img src={logo}/>
              </div>
              <div className="content-left--main-text">
                  {/* <h3>SEM ROAMING<br/>
                      SEM COBRANÇAS EXTRAS.<br/>
                      MENSAGENS DE <br/>
                      <span>WHATSAPP</span> ILIMITADAS.</h3> */}
              </div>
          </div>
      </div>
      <div className="content-right">
        <Numero/>
      </div>
  </div>

  
    
    
  );
}

export default App;
